import { render } from "./CertificateRequestDetails.vue?vue&type=template&id=285a5ffe&ts=true"
import script from "./CertificateRequestDetails.vue?vue&type=script&lang=ts"
export * from "./CertificateRequestDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__